import styled from "styled-components";

export const WatchDemoSection = styled.section`
  align-items: center;
  background-color: ${({theme}) => theme.colors.light};
  display: flex;
  min-height: 700px;
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    min-height: 600px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    min-height: 520px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    min-height: 480px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.medium}) {
    min-height: 390px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.tab}) {
    display: block;
    min-height: 430px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
    min-height: 340px;
  }
`;

export const HeadingSection = styled.div`
  flex: 1;
  @media (max-width:${({theme}) => theme.breakpoint.tab}) {
    position: relative;
    z-index: 9;
  }
`;

export const HeadingTitle = styled.h2`
  width: 320px;
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    width: 264px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    width: 242px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    width: 201px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.medium}) {
    width: 182px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.tab}) {
    color: ${({theme}) => theme.colors.basic};
    margin: 0 auto;
    margin-left: 25%;
  }
  @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
    margin-left: 100px;
    width: 144px;
  }
`;

export const DemoVideoSection = styled.div`
  flex: 1;
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    height: 360px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    height: 262px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.medium}) {
    height: 225px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.tab}) {
    margin-top: 36px;
    position: relative;
    z-index: 9;
  }
  @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
    margin-top: 32px;
    height: 200px;
  }
`;

export const StyledVideoDiv = styled.div`
  background-color: ${({theme}) => theme.colors.basic};
  border-radius: ${({theme}) => theme.radius.medium};
  box-shadow: 0 0 10px 0 ${({theme}) => theme.colors.default};
  height: 420px;
  left: -20px;
  overflow: hidden;
  position: relative;
  width: 730px;
  button {
    display: none;
  }
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    height: 350px;
    width: 630px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    height: 300px;
    width: 550px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    border-radius: ${({theme}) => theme.radius.normal};
    box-shadow: 0 0 8px 0 ${({theme}) => theme.colors.default};
    height: 262px;
    width: 470px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.medium}) {
    height: 210px;
    left: 0;
    width: 380px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.tab}) {
    margin: 0 auto;
  }
  @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
    height: 162px;
    width: 290px;
  }
  &.videoLink {
    box-shadow: 0 0 0 100px #000;
    height: auto;
    left: 50%;
    position: fixed;
    top: 50%;
    transform: translate(-50%, -50%);
    transition: all .3s ease-in-out;
    width: 100%;
    z-index: 999;
    button {
      display: block;
    }
  }
  .video-react .video-react-poster {
    background-color: ${({theme}) => theme.colors.basic};
  }
  .video-react .video-react-big-play-button {
    background-color: ${({theme}) => theme.colors.secondary};
    border-radius: 50%;
    border: none;
    box-shadow: 0 0 10px 1px ${({theme}) => theme.colors.default};
    font-size: 10em;
    height: 200px;
    left: 50%;
    top: 40%;
    transform: translate(-50%, -40px);
    transition: all .2s ease-in-out;
    width: 200px;
    @media (max-width:${({theme}) => theme.breakpoint.hd}) {
      font-size: 8em;
      height: 160px;
      width: 160px;
    }
    @media (max-width:${({theme}) => theme.breakpoint.large}) {
      box-shadow: 0 0 8px 0 ${({theme}) => theme.colors.default};
      font-size: 7em;
      height: 140px;
      width: 140px;
    }
    @media (max-width:${({theme}) => theme.breakpoint.default}) {
      font-size: 6em;
      height: 120px;
      width: 120px;
    }
    @media (max-width:${({theme}) => theme.breakpoint.medium}) {
      font-size: 5em;
      height: 100px;
      top: 45%;
      width: 100px;
    }
    @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
      font-size: 4em;
      height: 75px;
      top: 55%;
      width: 75px;
    }
    &:before {
      top: 20px;
      @media (max-width:${({theme}) => theme.breakpoint.default}) {
        top: 16px;
      }
      @media (max-width:${({theme}) => theme.breakpoint.medium}) {
        top: 12px;
      }
      @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
        top: 8px;
      }
    }
    &:hover {
      box-shadow: none;
    }
  }
`;

export const StyledVideoLink = styled.div`
  border-bottom: 2px solid transparent;
  color: ${({theme}) => theme.colors.secondary};
  margin-left: -50px;
  margin-top: 80px;
  transition: all .2s ease-in-out;
  width: fit-content;
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    margin-top: 60px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    margin-top: 40px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.tab}) {
    margin: 36px auto;
    a {
      font-size: ${({theme}) => theme.fonts.smallerSize};
    }
  }
  @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
    border-bottom: 1px solid transparent;
    margin: 30px auto;
    a {
      font-family: 'RubikRegular';
      font-size: ${({theme}) => theme.fonts.smallerSize};
    }
  }
  &:hover {
    border-bottom: 2px solid ${({theme}) => theme.colors.secondary};
    @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
      border-bottom: 1px solid ${({theme}) => theme.colors.secondary};
    }
  }
`;

export const ExitButton = styled.button`
  background-color: rgba(0,0,0,.5);
  border-radius: 5px;
  border: none;
  color: #fff;
  cursor: pointer;
  font-family: "RubikLight";
  padding: 6px 12px;
  position: absolute;
  right: 8px;
  top: 8px;
  z-index: 999;
`;